module.exports = __webpack_public_path__ + "fecbb9abe121e5aceab921d517de9b46.svg";